// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .range-combo-box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
} */
/* 
.range-combo-box input[type="range"]{
    width: calc(100% - 105px);
}
.range-combo-box input{
    margin-left: 5px;
    width: 90px;
} */

.range-label-combo {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.range-label-combo p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLInputs/ECLRange/ECLRange.css"],"names":[],"mappings":"AAAA;;;;;GAKG;AACH;;;;;;;GAOG;;AAEH;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":["/* .range-combo-box {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n} */\r\n/* \r\n.range-combo-box input[type=\"range\"]{\r\n    width: calc(100% - 105px);\r\n}\r\n.range-combo-box input{\r\n    margin-left: 5px;\r\n    width: 90px;\r\n} */\r\n\r\n.range-label-combo {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.range-label-combo p {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
